<template>
  <div id="talentPool">
    <div class="talent_pool_info">
      <el-input
        placeholder="请输入岗位名称/姓名"
        prefix-icon="el-icon-search"
        @blur="inputBlur"
        v-model="inputValue">
      </el-input>
      <div class="candidate_total">共 <span class="text">{{ this.talentPoolList.length }}</span> 位候选人</div>
      <div class="talent_pool_list">
        <div class="tab_item" v-for="(list, index) in talentPoolList" :key="index" @click="toUrl(list)">
          <div class="tab_item_top">
            <div class="picture">
              <img :src="list.img_url" alt="" />
            </div>
            <div class="text_self">
              <div class="tite_self">{{ list.name }}</div>
              <div class="tag" v-if="list.job_type">{{ list.job_type == 1 ? '自荐' : '内推' }}</div>
            </div>
            <div class="time_margin_top">投递时间：{{ list.send_time }}</div>
          </div>
          <div class="tab_item_info">
            <div class="info_left">应聘岗位：</div>
            <div class="info_right">{{ list.position }}</div>
          </div>
          <div class="tab_item_info">
            <div class="info_left">应聘部门：</div>
            <div class="info_right">{{ list.dept_name }}</div>
          </div>
          <div class="tab_item_info">
            <div class="info_left">联系电话：</div>
            <div class="info_right">{{ list.tel }}</div>
          </div>
          <div class="tab_item_info">
            <div class="info_left">邮 箱：</div>
            <div class="info_right setColor">{{ list.email }}</div>
          </div>
          <div class="tab_item_info">
            <div class="info_left">推 荐 人：</div>
            <div class="info_right setColor">{{ list.referrer_name }}</div>
          </div>
          <div class="tab_item_info">
            <div class="info_left">关 系：</div>
            <div class="info_right">{{ list.relation }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/apis/inside'
export default {
  data() {
    return {
      inputValue: '',
      talentPoolList: [],
    }
  },
  mounted() {
    this.talentPool()
  },
  methods: {
    // 跳转详情
    toUrl(list){
      this.$router.push({
        path: '/HR/deliverDetails',
        query: {
          recordUuid:list.recordUuid,
          type:1
        }
      })
    },
    //获取候选人
    talentPool() {
      api.talentPool({
        data: this.inputValue
      }).then(res => {
        if (res.code == 200) {
          this.talentPoolList = res.data
        }
      })
    },
    inputBlur() {
      this.talentPool()
    },
  },
}
</script>

<style lang="scss" scoped>
$zoom: 1020 / 375;
@media screen and (max-width: 600px) {
  #talentPool {
    width: 100%;
  }
}
@media screen and (min-width: 600px) {
  #talentPool {
    width: 276px * $zoom;
  }
}
#talentPool {
  font-size: 16px * $zoom;
  position: relative;
  .talent_pool_info {
    width: 100%;
    min-height: 100vh;
    // background: #F7F9FA;
    background: #fff;
    padding: 36px 32px;
    ::v-deep .el-input {
      .el-icon-search {
        font-size: 30px;
      }
      .el-input__inner {
        height: 72px;
        border: none;
        background: #F7F9FA;
        font-size: 26px;
        border-radius: 20px;
        &::placeholder {
          font-size: 26px;
          color: #999;
        }
      }
    }
    .candidate_total {
      margin: 24px 0;
      font-size: 24px;
      color: #666666;
      .text {
        color: #4EA27C;
      }
    }
    .talent_pool_list {
      .tab_item {
        width: 100%;
        background: #fff;
        margin-top: 24px;
        padding: 30px;
        border: 2px solid #DBDADA;
        border-radius: 16px;
        cursor: pointer;
        .tab_item_top {
          overflow: hidden;
          .picture {
            overflow: hidden;
            float: left;
            width: 95px;
            height: 95px;
            border-radius: 50%;
            background: #ccc;
            img {
              width: 100%;
              height: 100%;
            }
          }
          .text_self {
            float: left;
            margin-left: 20px;
            .tite_self {
              margin-top: 6px;
              font-size: 32px;
              font-weight: bold;
              color: #282B32;
            }
            .tag {
              display: flex;
              justify-content: center;
              align-items: center;
              width: 88px;
              height: 40px;
              margin-top: 6px;
              background: rgba(78,162,124,0.1);
              font-size: 24px;
              color: #4EA27C;
              border-radius: 4px;
            }
          }
          .time_margin_top {
            margin-top: 10px;
            float: right;
            font-size: 24px;
            color: #666666;
          }
        }
        .tab_item_line_height {
          line-height: 95px;
        }
        .tab_item_info {
          display: flex;
          margin-top: 20px;
          font-size: 30px;
          line-height: 42px;
          .info_left {
            width: 160px;
            color: #666666;
          }
          .info_right {
            color: #282B32;
          }
          .setColor {
            color: #0089FF;
          }
        }
      }
    }
  }
}

</style>